// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__2bIZO","Primary":"Button_Primary__31ihf","Danger":"Button_Danger__1MG8u"};